import { lazy } from "react";

export const AdminServicesAsync = lazy(() => import("./AdminServices"));
